/* eslint-disable no-console */

import {register} from 'register-service-worker'
import VueRegister_serviceConfig from "../vue.register_service.config";


var base_url = VueRegister_serviceConfig.getBaseURL();


if (process.env.NODE_ENV === 'production') {
	// register(`${base_url}service-worker.js`, {
	// 	ready() {
	//
	// 	},
	// 	registered() {
	//
	// 	},
	// 	cached() {
 	// 	},
	// 	updatefound() {
 	// 	},
	// 	updated () {
 	// 		//window.location.reload(true);
	// 	},
	// 	offline() {
 	// 	},
	// 	error(error) {
	// 		console.error('Error during service worker registration:', error)
	// 	}
	// })
}
